import {map} from 'rxjs/operators';
import {HttpService} from '../http-service.service';
import {ApiConst} from '../api-const';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class ReportGeneratorService {

  constructor(private httpService: HttpService) {
  }
  public getReportColumns(groupId: string): Observable<any> {
    return this.httpService.$post(ApiConst.getReportColumns, {'groupId': groupId}).pipe( map(res => {
      return res.body.datas;
    }));
  }
  public createReport(payload: any): Observable<any> {
    return this.httpService.$post(ApiConst.createReport, payload);
  }
}
